import { Entity } from '../../entities/entity';
import { FilterItem } from '../../entities/shared/filter';
import { FinanceDefaultView, FinanceViewFilters } from '../../entities/job/finance';
import { ExportFormat } from '../../entities/job/export.format';

export interface JobFinanceRequest {
    jobId: string;
    jobNumber: string;
    type: FinanceListView;
    date: Date;
    financeView?: FinanceDefaultView;
    timestamp?: any;
}

export interface FinanceFilters {
    text?: string;
    customers: FilterItem[];
    JobType: FilterItem[];
}

export interface GenerateCSVMessageRequest {
    type: string;
    exportFormat: ExportFormat;
    selectedMode: FinanceListView;
    rows: any[];
}

export interface FinanceDownloadRequest {
    billDateFrom?: Date;
    billDateTo?: Date;
    exportFormat?: ExportFormat;
    technicians?: Entity[];
    customers?: Entity[];
    statuses?: Entity[];
    selectedMode?: FinanceListView;
    type?: string;
    excludeAmountZero?: boolean;
    isTaxInclusiveFlag?: boolean;
}

export enum FinanceListView {
    CustomerBilling = 'Customer Billing',
    Subcontractor = 'Subcontractor (RCTI)',
}

export interface FinanceRequest {
    viewId: string;
    selectedMode: FinanceListView;
    throughDate: Date;
    selectedFilter: FinanceViewFilters;
}

